import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-default_zip",
  "use": "icon-default_zip-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-default_zip\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10,10h2v2H10Zm2-2h2v2H12ZM10,6h2V8H10Zm2-2h2V6H12Zm2,8v5H10V14h2V12Zm5,8V4H5V20Zm1,2H4a1,1,0,0,1-1-1V3A1,1,0,0,1,4,2H20a1,1,0,0,1,1,1V21A1,1,0,0,1,20,22Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol